export default __webpack_public_path__ + "222e3fc83a51c9f76b97b1e386da2032.svg";